import { render, staticRenderFns } from "./CustomDialogShow.vue?vue&type=template&id=bc95c8f0&scoped=true&"
import script from "./CustomDialogShow.vue?vue&type=script&lang=js&"
export * from "./CustomDialogShow.vue?vue&type=script&lang=js&"
import style0 from "./CustomDialogShow.vue?vue&type=style&index=0&id=bc95c8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc95c8f0",
  null
  
)

export default component.exports